// extracted by mini-css-extract-plugin
export default {"lpus":"lpu_lpus__iRXIb","lpu":"lpu_lpu__22t-4"};